<template>
    <div class="acomodar">
        <b-alert show variant="danger">
    <h4 class="alert-heading">ERROR DE RUTA</h4>
    <p class="mt-4">
      LA  RUTA DE LA PAGINA QUE ESTAS BUSCANDO NO EXITE POR FAVOR VERIFICAR EL URL SI ESTAS EN LO CORRECTO GRACIAS!!!!
    </p>
    <hr>
    <p class="mt-5">
      TENER EN CUENTA EL URL  GRACIAS!!!
    </p>
  </b-alert>
    </div>
</template>

<script>
export default {
    name: 'SolimanologErrorRuta',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style  scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 2%;
  margin-right: 2%;
  padding-top:8%;
padding-right: 6%;
padding-left: 6%;
  height: auto;
  border-radius: 10px 10px 10px 10px;
  overflow-x: auto;
  overflow-y: none;
}

</style>